
(() => {
  'use strict';
  const offer = document.getElementById('product-offer');
  const inlineOffer = document.getElementById('inline-product-offer');
  const sticky = document.getElementById('product-dock');
  const modal = document.getElementById('offer-modal');
  const trigger = document.getElementById('offer-trigger');
  const opener = document.getElementById('open-offer');
  let returnFocus = null;
  function openOffer() {
    if (modal.open) return;
    returnFocus = document.activeElement;
    modal.showModal();
    document.documentElement.classList.add('offer-open');
  }
  function closeOffer() { modal.close(); }
  opener.addEventListener('click',openOffer);
  document.getElementById('close-offer').addEventListener('click',closeOffer);
  // Native dialog provides Escape dismissal and keeps keyboard focus inside.
  modal.addEventListener('close',() => {
    document.documentElement.classList.remove('offer-open');
    const target = returnFocus && returnFocus !== document.body && returnFocus.isConnected ? returnFocus : opener;
    target.focus({preventScroll:true});
  });
  let backdropDown = false;
  const outside = event => { const rect=modal.getBoundingClientRect();return event.clientX<rect.left || event.clientX>rect.right || event.clientY<rect.top || event.clientY>rect.bottom; };
  modal.addEventListener('pointerdown',event=>{backdropDown=event.target===modal && outside(event);});
  modal.addEventListener('click',event=>{if(backdropDown && event.target===modal && outside(event))closeOffer();backdropDown=false;});
  const player = document.querySelector('vturb-smartplayer');
  const revealKey = 'stabledays:offer:6aa53eeef11c250390089f52';
  const storage = { get(key,fallback) { try { return JSON.parse(localStorage.getItem(key)) ?? fallback; } catch { return fallback; } }, set(key,value) { try { localStorage.setItem(key,JSON.stringify(value)); } catch {} } };
  let visible = false;
  function reveal() {
    if (visible) return;
    visible = true;
    inlineOffer.hidden = false;
    storage.set(revealKey,true);
    document.body.classList.add('has-offer');
    sticky.hidden = false;
    openOffer();
  }
  let bound = false;
  function bindDelay() {
    if (bound || typeof player.displayHiddenElements !== 'function') return;
    bound = true;
    player.displayHiddenElements(1795, ['#offer-trigger'], { persist:true, callback:reveal });
  }
  if (storage.get(revealKey,false) === true) reveal();
  player.addEventListener('player:ready',bindDelay);
  bindDelay();
  // Accommodate player versions that show elements without invoking callback.
  new MutationObserver(() => { if (!visible && getComputedStyle(trigger).display !== 'none') reveal(); }).observe(trigger,{attributes:true,attributeFilter:['style','class']});
  const embed = document.createElement('script');
  embed.src = 'https://scripts.converteai.net/c338cc06-a7d8-453a-ae69-8cc34edae5fb/players/6aa53eeef11c250390089f52/v4/player.js';
  embed.async = true;
  embed.onerror = () => { document.getElementById('video-error').hidden = false; };
  document.head.appendChild(embed);

  const supplied = JSON.parse(document.getElementById('discussion-data').textContent);
  const list = document.getElementById('discussion-list');
  const key = 'stabledays:discussion:v1';
  let saved = storage.get(key,[]);
  if (!Array.isArray(saved)) saved = [];
  saved = saved.filter(item => item && typeof item.text === 'string' && typeof item.id === 'string');
  let likes = storage.get(key+':likes',[]);
  if (!Array.isArray(likes)) likes=[];
  let sorted = false;
  const make = (tag, cls, text) => { const node=document.createElement(tag); if(cls)node.className=cls; if(text!==undefined)node.textContent=text; return node; };
  function render() {
    list.replaceChildren();
    document.getElementById('discussion-count').textContent=147+saved.length;
    const originals = sorted ? [...supplied].sort((a,b)=>b.likes-a.likes) : supplied;
    const roots = [...saved.filter(item=>!item.parent),...originals];
    for (const item of roots) {
      list.appendChild(row(item));
      saved.filter(reply=>reply.parent===item.id).forEach(reply=>list.appendChild(row(reply,true)));
    }
  }
  function row(item,isReply=false) {
    const li=make('li','comment'+(isReply || item.id.startsWith('r') ? ' is-reply' : ''));
    const local=item.id.startsWith('local-');
    const author=local?'You':item.author;
    li.appendChild(make('span','comment-avatar',local?'Y':author.replace('@','').slice(0,2).toUpperCase()));
    const body=make('div','comment-main');
    body.appendChild(make('span','comment-author',author));
    body.appendChild(make('span','comment-time',local?'Saved on this device':item.time));
    const commentText=make('p','',item.text);if(local)commentText.setAttribute('data-no-translate','');body.appendChild(commentText);
    const actions=make('div','comment-actions');
    const like=make('button','','♡ '+((item.likes||0)+(likes.includes(item.id)?1:0)));
    like.type='button';like.setAttribute('aria-pressed',String(likes.includes(item.id)));like.setAttribute('aria-label','Like comment by '+author);
    like.addEventListener('click',()=>{ likes=likes.includes(item.id)?likes.filter(id=>id!==item.id):[...likes,item.id];storage.set(key+':likes',likes);render(); });
    actions.appendChild(like);
    if(local){
      const remove=make('button','','Delete');remove.type='button';remove.addEventListener('click',()=>{saved=saved.filter(value=>value.id!==item.id&&value.parent!==item.id);storage.set(key,saved);render();});actions.appendChild(remove);
    }
    const reply=make('button','','Reply');reply.type='button';actions.appendChild(reply);
    reply.addEventListener('click',()=>{
      if(body.querySelector('form')){body.querySelector('form').remove();return;}
      const form=make('form','reply-editor comment-form');const label=make('label','','Your reply (saved on this device)');
      const input=make('textarea');input.required=true;input.maxLength=2000;label.appendChild(input);form.appendChild(label);
      const submit=make('button','action','Save reply');submit.type='submit';form.appendChild(submit);
      form.addEventListener('submit',event=>{event.preventDefault();add(input.value,item.id);});body.appendChild(form);input.focus();
    });
    body.appendChild(actions);li.appendChild(body);return li;
  }
  function add(text,parent) {
    if(!text.trim())return;
    saved.unshift({id:'local-'+Date.now()+'-'+Math.random().toString(36).slice(2),text:text.trim(),parent:parent||null});
    storage.set(key,saved);render();
  }
  document.getElementById('new-comment').addEventListener('submit',event=>{event.preventDefault();const input=event.currentTarget.elements.comment;add(input.value);input.value='';});
  document.getElementById('sort-comments').addEventListener('click',event=>{sorted=!sorted;event.currentTarget.textContent=sorted?'Sort: Most liked':'Sort: Original order';render();});
  render();
})();
